import { veiraCartState } from './veira-cart-state.js?v=20261027-4';

class VeiraCartIcon extends HTMLElement {
  connectedCallback() {
    this.unsubscribe?.();
    this.unsubscribe = veiraCartState.subscribe(count => {
      if (!this.isConnected) return;
      this.classList.toggle('header-actions__cart-icon--has-cart', count > 0);
      const bubble = this.querySelector('[ref="cartBubble"]');
      const number = this.querySelector('[ref="cartBubbleCount"]');
      if (bubble) {
        bubble.hidden = count === 0;
        bubble.classList.toggle('visually-hidden', count === 0);
        bubble.classList.remove('cart-bubble--animating');
      }
      if (number) { number.textContent = count > 99 ? '99+' : String(count); number.classList.remove('hidden'); }
    });
  }
  disconnectedCallback() { this.unsubscribe?.(); }
}

if (!customElements.get('cart-icon')) customElements.define('cart-icon', VeiraCartIcon);
